import React, { useState, Dispatch, SetStateAction, FC } from 'react'
import { Tabs, TabPane } from 'components/SA/Tabs'
import Accordion from 'components/SA/Accordion'
import { useSelector } from 'react-redux'
import { getAboutArtist, getBadges } from '../../selectors'
import styles from './AboutArtist.module.scss'
import classNames from 'classnames'
import AboutArtistHeader from './AboutArtistHeader'
import { replaceBadges } from 'lib/badges'
import useQA from 'hooks/useQA'
type Props = {
  showUploader: boolean
  setFollowedUserArray: Dispatch<SetStateAction<ReadonlyArray<number>>>
  followedUserArray: ReadonlyArray<number>
  setTotalFollowers: Dispatch<SetStateAction<number>>
  totalFollowers: number
}
const MAX_CHAR_COUNT = 1251
const AboutArtist: FC<Props> = ({
  showUploader,
  followedUserArray,
  setFollowedUserArray,
  totalFollowers,
  setTotalFollowers,
}) => {
  const aboutArtist = useSelector(getAboutArtist)
  const badges = useSelector(getBadges)
  const [isExpanded, setIsExpanded] = useState(false)
  const { testId } = useQA()
  const toggleReadMore = () => {
    setIsExpanded(!isExpanded)
  }

  const shouldTruncate = (text) => text.length > MAX_CHAR_COUNT
  const displayText = (text) => {
    return isExpanded || !shouldTruncate(text) ? text : text.slice(0, MAX_CHAR_COUNT) + '...'
  }
  const cleanedObj = Object.fromEntries(
    Object.entries(aboutArtist).filter(([key, value]) => value !== '' && key !== 'events')
  )

  const aboutSectionItems = Object.entries(aboutArtist)
    .filter(([key, value]) => value !== '' && key !== 'events')
    .map(([key, value]) => ({
      title: key.toUpperCase(),
      content: (
        <div className={styles.tabContent}>
          <p
            className={styles.text}
            {...testId('about-artist-text')}
            dangerouslySetInnerHTML={{
              __html: `${(displayText(value) || '').replace(/\n/g, '<br />')}`,
            }}
          />
          {shouldTruncate(value) && (
            <button onClick={toggleReadMore} className={styles.readMoreButton}>
              {isExpanded ? 'Read less' : 'Read more'}
            </button>
          )}
        </div>
      ),
    }))

  if (badges.length > 0) {
    cleanedObj.recognition = badges
    aboutSectionItems.push({
      title: 'RECOGNITION',
      content: (
        <div className={styles.badgesWrapper} {...testId('badges-wrapper')}>
          {replaceBadges(badges).map(({ image, title }, key) => {
            return (
              <div className={styles.badges} key={key}>
                <img className={styles.badgeImage} src={image} alt={`link - ${title}`} />
                <p className={styles.title}>{title}</p>
              </div>
            )
          })}
        </div>
      ),
    })
  }

  return (
    <>
      <div
        className={classNames(
          {
            [styles.aboutArtistDesktopHide]: showUploader,
          },
          styles.aboutArtistDesktop
        )}
        {...testId('about-artist-desktop')}
      >
        <AboutArtistHeader
          followedUserArray={followedUserArray}
          setFollowedUserArray={setFollowedUserArray}
          setTotalFollowers={setTotalFollowers}
          totalFollowers={totalFollowers}
        />
        <Tabs isOtherContentHidden={true}>
          {Object.entries(cleanedObj).map(([key, value]) => {
            if (key === 'recognition') {
              return (
                <TabPane label='RECOGNITION' id='artist_recognition_tab' key={key}>
                  <div className={styles.badgesWrapper} {...testId('badges-wrapper')}>
                    {replaceBadges(badges).map(({ image, title }, key) => {
                      return (
                        <div className={styles.badges} key={key}>
                          <img className={styles.badgeImage} src={image} alt={`link - ${title}`} />
                          <p className={styles.title}>{title}</p>
                        </div>
                      )
                    })}
                  </div>
                </TabPane>
              )
            }
            return (
              <TabPane label={key.toUpperCase()} id={`artist_${key}_tab`} key={key}>
                <div className={styles.tabContent}>
                  <p
                    className={styles.text}
                    {...testId('about-artist-text')}
                    dangerouslySetInnerHTML={{
                      __html: `${(displayText(value) || '').replace(/\n/g, '<br />')}`,
                    }}
                  />
                  {shouldTruncate(value) && (
                    <button onClick={toggleReadMore} className={styles.readMoreButton}>
                      {isExpanded ? 'Read less' : 'Read more'}
                    </button>
                  )}
                </div>
              </TabPane>
            )
          })}
        </Tabs>
      </div>

      <div
        className={classNames(
          {
            [styles.aboutArtistMobileHide]: showUploader,
          },
          styles.aboutArtistMobile
        )}
        {...testId('about-artist-mobile')}
      >
        <Accordion
          items={aboutSectionItems}
          contentCustomStyle={styles.customAccordionContent}
          itemCustomStyle={styles.customAccordionItem}
          headerCustomStyle={styles.customAccordionHeader}
        />
      </div>
    </>
  )
}

export default AboutArtist
